module.exports = __webpack_public_path__ + "img/bz.bzfb56b21.svg";